import React from "react"
import Section from "./BlockSection"
import { get } from "lodash"

const ContentBlocks = ({ contentBlocks }) => {

  return (
    contentBlocks.map(block => {
      const type = get(block, "system.type")
      const id = get(block, "system.id")

      return (
        {
          section: <Section section={block} key={id} />,
        }[type] || <>Not found: {type}</>
      )
    })
  )
}

export default ContentBlocks
